import { gql, useMutation } from '@apollo/client'
import { LOCATION_DATA } from './locations'

const INSTRUMENT_DATA =  gql`
        fragment InstrumentData on InstrumentGenericType {
            id
            panId
            active
            pgn
            notes
            blickoVersion
            hardwarestatus {
              id
              time
              data
              summary
              user {
                username
              }
            }
            networkOperator {
              username
            }
            comments {
              id
              user {
                username
              }
              text
              time
            }
            deployment {
              id
              time
              description
              location {
                id
                name
              }
              user {
                username
              }
            }
            stati {
              id
              time
              description
              status {
                id
                name
              }
              user {
                username
              }
            }
            issues {
              id
              opened
              closed
              issue {
                id
                description
                category {
                  id
                  name
                }
              }
              user {
                username
              }
              actions {
                id
                time
                description
                user {
                  username
                }
              }
            }
            currentNopsCheck { checkDate, checkSummary, checkData}
            currentRqCheck {lastChecked, data, routineQcId}
        }
`;

const INSTRUMENT_OVERVIEW_DATA = gql`
        fragment InstrumentOverviewData on InstrumentGenericType {
            id
            panId
            active
            pgn
            notes
            blickoVersion
            currentHardwareStatus {
              id
              displayName
            }
            networkOperator {
              username
            }
            currentDeployment {
              id
              location {
                id
                name
              }
            }
            currentStatusAssignment {
              id
              status {
                id
                name
              }
            }
            issues(openOnly: true) {
              id
              closed
              issue {
                id
                category {
                  id
                  name
                }
              }
            }
            currentNopsCheck { checkDate }
            currentRqCheck { lastChecked }
        }
`;

export const GET_INSTRUMENT_NOPS_CHECK = gql`
query InstrumentNopsCheck($input: ID!) {
  instrument(id: $input) {
    id
    currentNopsCheck { checkDate checkSummary checkData }
  }
}
`;

export const GET_INSTRUMENT_RQ_CHECK = gql`
query InstrumentRqCheck($input: ID!) {
  instrument(id: $input) {
    id
    currentRqCheck { lastChecked data routineQcId }
  }
}
`;

export const INSTRUMENT_DETAIL = gql `
query InstrumentDetail($input: ID!) {
  instrument(id: $input){
    ...InstrumentData
  }
}
${INSTRUMENT_DATA}
`;

export const GET_INSTRUMENT_COMMENTS = gql`
query InstrumentComments($input: ID!) {
  instrument(id: $input) {
    id
    comments {
      id
      user {
        username
      }
      text
      time
    }
  }
}
`

export const GET_INSTRUMENT_ISSUES = gql`
query InstrumentIssues($input: ID!) {
  instrument(id: $input) {
    id
    issues {
      id
      opened
      closed
      issue {
        id
        description
        category {
          id
          name
        }
      }
      user {
        username
      }
      actions {
        id
        time
        description
        user {
          username
        }
      }
    }
  }
}
`

export const GET_INSTRUMENT_DEPLOYMENTS = gql`
query InstrumentDeployments($input: ID!) {
  instrument(id: $input) {
    id
    deployment {
      id
      time
      description
      location {
        id
        name
      }
      user {
        username
      }
    }
  }
}
`

export const GET_INSTRUMENT_STATI = gql`
query InstrumentStati($input: ID!) {
  instrument(id: $input) {
    id
    stati {
      id
      time
      description
      status {
        id
        name
      }
      user {
        username
      }
    }
  }
}
`

export const GET_INSTRUMENT_HARDWARESTATUS = gql`
query InstrumentHardwareStatus($input: ID!) {
  instrument(id: $input) {
    id
    hardwarestatus {
      id
      time
      data
      summary
      user {
        username
      }
    }
  }
}
`

export const CREATE_COMMENT = gql `
mutation CreateComment($input: CommentCreateGenericType!) {
  createComment(newComment: $input) {
    ok
    comment {
      id
      user {
        username
      }
      text
      time
    }
  }
}
`

export const UPDATE_COMMENT = gql `
mutation UpdateComment($input: CommentUpdateGenericType!) {
  updateComment(newComment: $input) {
    ok
    comment {
      id
      user {
        username
      }
      text
      time
    }
  }
}
`

export const DELETE_COMMENT = gql `
mutation DeleteComment($input: ID!) {
  deleteComment(id: $input) {
    ok
    comment {
      id
      user {
        username
      }
      text
      time
    }
  }
}
`


/*export const GET_INSTRUMENTS = gql`
query {
    allInstruments {
        results {
            ...InstrumentData
        }
        totalCount
    }
}
${INSTRUMENT_DATA}
`;*/

export const GET_INSTRUMENTS = gql`
query {
    instruments {
        ...InstrumentData
    }
}
${INSTRUMENT_DATA}
`;


export const GET_INSTRUMENTS_AND_HEADERS = gql`
    query GetInstrumentsAndHeaders($start: CustomDateTime, $end: CustomDateTime) {
        instruments {
            ...InstrumentData
            partialHeaders(time_Gte: $start, time_Lte: $end) {
                time
                data 
            }
        }
    }
    ${INSTRUMENT_DATA}
`;

export const GET_INSTRUMENTS_AND_HEADERS_OVERVIEW = gql`
    query GetInstrumentsAndHeadersOverview($start: CustomDateTime, $end: CustomDateTime, $l2Start: Date!, $l2End: Date!) {
        instruments {
            ...InstrumentOverviewData
            partialHeaders(time_Gte: $start, time_Lte: $end) {
                time
                data 
            }
        }
        l2Files(dateGte: $l2Start, dateLte: $l2End) {
            filename
            metadataDate
            metadataPanId
        }
    }
    ${INSTRUMENT_OVERVIEW_DATA}
`;


export const LIST_INSTRUMENTS = gql`
query {
  instruments {
    id
  }
}
`

export const UPDATE_INSTRUMENT_MUTATION = gql`
  mutation UpdateInstrumentMutation($input: UpdateInstrumentMutationInput!) {
    updateInstrumentMutation(input: $input) {
      ok
      instrument {
        ...InstrumentData
      }
    }
  }
  ${INSTRUMENT_DATA}
`;
